namespace Areas.Budget.AutoLink {
    "use strict";

    export function processAutoLinks() {

        const linkedGrid = $("#BudgetListGrid").dxDataGrid("instance");
        const accountId = linkedGrid.option("accountId");

        let url = `/Budget/AutoLinked/ProcessAllAutoLinks/${accountId}`;

        const method = "POST";
        sendRequest(url,
            "",
            method,
            (data) => {
                Areas.reloadPage();
            });


    }


}
